var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useState } from 'react';
import { ValidatorProvider } from "react-admin-base";
import { FormattedMessage } from "react-intl";
import { Alert, Form } from 'reactstrap';
import LoadingButton from "../Components/LoadingButton";
import { ValidationErrors } from './Validator';
export default function EntityEditor({ entity, disabled, children, onSave, saveButtonClassName, saveButtonText }) {
    const [data, _2, save, loading] = entity;
    const [saved, setSaved] = useState(false);
    const [error, setError] = useState(false);
    const onSubmit = useCallback(function (e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            e.stopPropagation();
            if (saved) {
                setSaved(false);
            }
            if (error) {
                setError(null);
            }
            try {
                yield save();
                onSave && onSave();
                setSaved(true);
            }
            catch (e) {
                console.error(e);
                setError((e.response && e.response.data && e.response.data.message) || (error.data && error.data.message) || e.data || e.message || e);
            }
            finally {
            }
        });
    }, [save, saved, error]);
    const savedAlert = saved && React.createElement(Alert, { color: "success", toggle: () => setSaved(false) },
        React.createElement("i", { className: "fas fa-check-circle me-2" }),
        React.createElement(FormattedMessage, { id: "ENTITY.SAVED" }));
    return React.createElement(ValidatorProvider, null,
        React.createElement(Form, { onSubmit: onSubmit, disabled: !!loading || !!disabled },
            loading && React.createElement(Alert, { color: "warning", toggle: () => setSaved(false) },
                React.createElement("i", { className: "fa fa-spin fa-spinner" }),
                ' ',
                React.createElement(FormattedMessage, { id: "PLEASE_WAIT" })),
            savedAlert,
            error && React.createElement(Alert, { color: "danger", toggle: () => setError(null) }, error),
            React.createElement("fieldset", { disabled: !!loading || !!disabled }, children),
            React.createElement(ValidationErrors, null),
            savedAlert,
            React.createElement(LoadingButton, { className: saveButtonClassName || "col-md-12 mt-3", loading: loading, type: "submit", color: "primary" },
                saveButtonText || React.createElement(FormattedMessage, { id: "ENTITY.SAVE" }),
                " ",
                React.createElement("i", { className: "fas fa-save fa-lg" }))));
}
